import { Container } from '../../../../../../../../components/container/container';
import { Input } from '../../../../../../../../components/input/input';
import { PasswordInput } from '../../../../../../../../components/input/password-input';
import { useCompanyAdminsCreateModalStep2 } from './use-company-admins-create-modal-step-2';

export const CompanyAdminsCreateModalStep2 = () => {
  const { admin, handleChangeInput, t } = useCompanyAdminsCreateModalStep2();

  return (
    <Container>
      <Container label={t('Логин')} required>
        <Input name="login" onChange={handleChangeInput} value={admin?.login} autoComplete="off" />
      </Container>
      <Container label={t('Пароль')} required>
        <PasswordInput
          name="password"
          onChange={handleChangeInput}
          value={admin?.password}
          autoComplete="new-password"
        />
      </Container>
      <Container label={t('Повторите пароль')} required>
        <PasswordInput
          name="repeat_password"
          onChange={handleChangeInput}
          autoComplete="new-password"
          value={admin?.repeat_password}
        />
      </Container>
    </Container>
  );
};
